import { useTranslate } from '@ur-solutions/react-hooks'
import type { DietSettingsSalaryWorkTime } from './queries'

export const SalaryWorkTimeHeading: React.FC<{
  salaryWorkTime: DietSettingsSalaryWorkTime
}> = ({ salaryWorkTime }) => {
  const texts = useTranslate({ personal: 'settings.generation-rules.personal' })
  return (
    <h3 className="font-semibold text-stone-900">
      {salaryWorkTime.name}
      {salaryWorkTime.user && (
        <span className="ml-2 text-sm font-normal text-stone-500">
          {texts.personal}: {salaryWorkTime.user.fullName}
        </span>
      )}
    </h3>
  )
}
